/* eslint-disable react/prop-types */
import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { useAuth } from "@/hooks/useAuth";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "@/store/loader";
import toast from "react-hot-toast";

export const GoogleAuthButton = ({ isRegister = true }) => {
  const dispatch = useDispatch();
  const { register, login } = useAuth();

  const handleGoogleSuccess = async (tokenResponse) => {
    dispatch(showLoader());

    try {
      // 1. Fetch the user details from google.
      const res = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
        headers: {
          Authorization: `Bearer ${tokenResponse.access_token}`,
        },
      });

      const user = await res.json(); // { name, email, sub, picture }

      const data = {
        name: user.name,
        email: user.email,
        password: user.sub, // Using google sub as password
        password_confirmation: user.sub,
        remember: true,
      };

      // register /login the user into the application.
      try {
        if (isRegister) {
          await register(data);
        } else {
          await login({
            email: data.email,
            password: data.password,
            remember: true,
          });
        }
      } catch (err) {
        console.log(err, "error");
        toast.error(err?.message || "Unknown error occurred");
      }
    } catch (error) {
      console.error("Google Login Failed:", error);
    } finally {
      dispatch(hideLoader());
    }
  };

  const loginWithGoogle = useGoogleLogin({
    onSuccess: handleGoogleSuccess,
    onError: () => console.log("Google Login Error"),
  });

  return (
    <button
      onClick={() => loginWithGoogle()}
      className="w-full flex items-center justify-center gap-3 border  rounded-2xl px-4 py-3.5  transition  hover:dark:bg-accent/70 dark:bg-accent dark:border-input/70"
    >
      <span className="h-5 w-5">
        {/* Google Icon */}
        <svg viewBox="0 0 533.5 544.3" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M533.5 278.4c0-17.7-1.4-35-4.3-51.8H272v98h147.4c-6.3 33.8-25 62.5-53.3 81.7v68.3h86.2c50.4-46.5 81.2-115.1 81.2-196.2z"
            fill="#4285f4"
          />
          <path
            d="M272 544.3c72.6 0 133.6-24 178.2-65.3l-86.2-68.3c-24 16.1-54.7 25.7-92 25.7-70.7 0-130.6-47.8-152-112.1h-89.7v70.5C82.5 477.1 170.5 544.3 272 544.3z"
            fill="#34a853"
          />
          <path
            d="M120 324.3c-10.5-31.3-10.5-64.9 0-96.2V157.6h-89.7C10.7 204.1 0 248.4 0 294.2s10.7 90.1 30.3 136.6L120 324.3z"
            fill="#fbbc04"
          />
          <path
            d="M272 107.7c39.5-.6 77.5 13.8 106.5 39.6l79.5-79.5C405.6 24 343.9 0 272 0 170.5 0 82.5 67.2 30.3 157.6l89.7 70.5c21.4-64.2 81.3-112.1 152-112.1z"
            fill="#ea4335"
          />
        </svg>
      </span>
      <span className="font-poppins fs-16 text-[#424242] dark:text-foreground">
        Continue with Google
      </span>
    </button>
  );
};
